// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CommentStatus } from './comment-status';
import {
    CommentStatusFromJSON,
    CommentStatusFromJSONTyped,
    CommentStatusToJSON,
    CommentStatusToJSONTyped,
} from './comment-status';

/**
 * 
 * @export
 * @interface UpdateCommentRequest
 */
export interface UpdateCommentRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCommentRequest
     */
    resolution_comment?: string;
    /**
     * 
     * @type {CommentStatus}
     * @memberof UpdateCommentRequest
     */
    status: CommentStatus;
}



/**
 * Check if a given object implements the UpdateCommentRequest interface.
 */
export function instanceOfUpdateCommentRequest(value: object): value is UpdateCommentRequest {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function UpdateCommentRequestFromJSON(json: any): UpdateCommentRequest {
    return UpdateCommentRequestFromJSONTyped(json, false);
}

export function UpdateCommentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCommentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'resolution_comment': json['resolution_comment'] == null ? undefined : json['resolution_comment'],
        'status': CommentStatusFromJSON(json['status']),
    };
}

export function UpdateCommentRequestToJSON(json: any): UpdateCommentRequest {
    return UpdateCommentRequestToJSONTyped(json, false);
}

export function UpdateCommentRequestToJSONTyped(value?: UpdateCommentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'resolution_comment': value['resolution_comment'],
        'status': CommentStatusToJSON(value['status']),
    };
}
